import { render, staticRenderFns } from "./LiveStreamPlus.vue?vue&type=template&id=2f916ffc&scoped=true&"
import script from "./LiveStreamPlus.vue?vue&type=script&lang=js&"
export * from "./LiveStreamPlus.vue?vue&type=script&lang=js&"
import style0 from "./LiveStreamPlus.vue?vue&type=style&index=0&id=2f916ffc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f916ffc",
  null
  
)

export default component.exports